export default "{\n    \"label\": \"Categorías de servicio\",\n    \"placeholder\": \"Seleccione categorías de servicio\"\n}"